export default __webpack_public_path__ + "static/media/logo_small.bb3e26b0.svg";